/**
 * A simpler object merge. Object.assign addresses some use cases
 * we do not need, such as direct membership and the ability to merge
 * more than one object.
 */

"use strict";

exports.__esModule = true;
exports["default"] = merge;

function merge(a, b) {
  if (b != null) {
    for (var key in b) {
      a[key] = b[key];
    }
  }

  return a;
}

module.exports = exports["default"];
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9tZXJnZS5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7cUJBTXdCLEtBQUs7O0FBQWQsU0FBUyxLQUFLLENBQUUsQ0FBQyxFQUFFLENBQUMsRUFBRTtBQUNuQyxNQUFJLENBQUMsSUFBSSxJQUFJLEVBQUU7QUFDYixTQUFLLElBQUksR0FBRyxJQUFJLENBQUMsRUFBRTtBQUNqQixPQUFDLENBQUMsR0FBRyxDQUFDLEdBQUcsQ0FBQyxDQUFDLEdBQUcsQ0FBQyxDQUFBO0tBQ2hCO0dBQ0Y7O0FBRUQsU0FBTyxDQUFDLENBQUE7Q0FDVCIsImZpbGUiOiJzcmMvbWVyZ2UuanMiLCJzb3VyY2VzQ29udGVudCI6WyIvKipcbiAqIEEgc2ltcGxlciBvYmplY3QgbWVyZ2UuIE9iamVjdC5hc3NpZ24gYWRkcmVzc2VzIHNvbWUgdXNlIGNhc2VzXG4gKiB3ZSBkbyBub3QgbmVlZCwgc3VjaCBhcyBkaXJlY3QgbWVtYmVyc2hpcCBhbmQgdGhlIGFiaWxpdHkgdG8gbWVyZ2VcbiAqIG1vcmUgdGhhbiBvbmUgb2JqZWN0LlxuICovXG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIG1lcmdlIChhLCBiKSB7XG4gIGlmIChiICE9IG51bGwpIHtcbiAgICBmb3IgKHZhciBrZXkgaW4gYikge1xuICAgICAgYVtrZXldID0gYltrZXldXG4gICAgfVxuICB9XG5cbiAgcmV0dXJuIGFcbn1cbiJdfQ==




/*****************
 ** WEBPACK FOOTER
 ** ./~/microcosm/merge.js
 ** module id = 92
 ** module chunks = 0
 **/